module.exports = __webpack_public_path__ + "img/bricks.9e8b01e7.9e8b01e7.jpg";